import React from 'react';
import parse from 'html-react-parser';
import Card from '../Card';
import Graphics from '../Graphics';
import { IconLinkArrow } from '../../utils/icons';
import { TChapter, TRecommendations } from '../../utils/types';

interface PdfProps {
	title: string
	pensionsAlder?: number
	recommendationsData: TRecommendations
	introTitle: string
	introText: string
	phnNumber: string
	allData: TChapter[]
  }

const PdfNy = (props: PdfProps) => {
	const { title, pensionsAlder, recommendationsData, introText, introTitle, phnNumber, allData } = props;
	const date = new Date();
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	const currentDate = `${day}/${month}/${year}`;

	const pdfContactTitle = 'Kontakt os';

	return (
		<div className="pdf-ny">
			<section className="pdf-page">
				<header className="pdf-header">
					<p>{ title }</p>
					<p>{ currentDate }</p>
				</header>
				<section className="pdf-core">
					<div className="pdf-message">
						<h1>{ introTitle }</h1>
						{ parse(introText) }
						{ recommendationsData && (
							<ul className="pdf-ul">
								{ recommendationsData.Anbefalinger?.map((e: { Link: string; Title: string; }, i: React.Key) => {
									return (
										<li key={ i }>
											<IconLinkArrow />
											<a href={ e.Link } target="_blank" rel="noreferrer">{ e.Title }</a>
										</li>
									);
								}) }
							</ul>
						) }
					</div>
					<div className="pdf-contact">
						<p>{ pdfContactTitle }</p>
						<h3>{ phnNumber }</h3>
					</div>
				</section>
				<section className="pdf-snacks">
					{ allData &&
						allData.map((dataElement: any, dataIndex: React.Key) => {
							return (
								<div className={ dataElement.Snack[0].Cards.length > 0 ? 'center-content' : 'content' } key={ dataIndex }>
									{ dataElement.Snack.map((snackElement: any, snackIndex: React.Key) => {
										const cardData = snackElement.Cards
											? snackElement.Cards.map((e: any, i: React.Key) => {
												return <Card cardData={ e } key={ i } />;
											})
											: null;

										const accordionData = snackElement.Accordions
											? snackElement.Accordions.map((e: any, i: React.Key) => {
												return (
													<div className="pdf-accordion" key={ i }>
														<p>
															<strong>{ e.Title }</strong>
														</p>
														{ parse(e.Text) }
													</div>
												);
											})
											: null;

										return (
											<div key={ `${dataIndex}-${snackIndex}` } className="content-container">
												{ pensionsAlder && snackElement.Text && snackElement.Text.includes('er din folkepensionsalder') && <h1 className="f70">{ pensionsAlder } år</h1> }
												{ snackElement.Text && (!snackElement.Text.includes('pensionsinfo.dk') && !snackElement.Text.includes('pension andre steder')) && parse(snackElement.Text) }
												{ cardData && <div className="lhp-cards">{ cardData }</div> }
												{ accordionData }
											</div>
										);
									}) }
									{ !dataElement.Snack[0].Cards.length && <Graphics data={ dataElement.Graphic } /> }
								</div>
							);
						}) }
				</section>
			</section>
		</div>
	);
};

export default PdfNy;
